import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import Loading from "components/common/loading/Loading";
import PatientComplianceAnalyticChart from "./chart/PatientComplianceAnalyticChart";
import PatientComplianceAnalyticStat from "./PatientComplianceAnalyticStat";
import { useGetPatientComplianceAnalyticQuery } from "app/store/dashboard/patient_compliance_analytic/api/patientComplianceAnalyticApi";

import { useSelector } from "react-redux";
import PatientComplianceAnalyticYearlyFilter from "./filters/PatientComplianceAnalyticYearlyFilter";
import PatientComplianceAnalyticAccountFilter from "./filters/PatientComplianceAnalyticAccountFilter";

const PatientComplianceAnalytic = () => {
  const { yearlyFilter, accountFilter } = useSelector(
    (state) => state.patientComplianceAnalytic
  );

  const { data, isLoading, isFetching } = useGetPatientComplianceAnalyticQuery(
    { yearlyFilter, accountFilter },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <Card
      elevation={0}
      style={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ marginBottom: "20px", width: "100%" }}
        >
          <Grid item>
            <Typography
              variant="h6"
              style={{ fontSize: "1.125rem", fontWeight: 500 }}
            >
              Patient Compliance Analytics
            </Typography>
          </Grid>
          <Grid item>
            <Grid container flexDirection="row" alignItems="center">
              <PatientComplianceAnalyticAccountFilter />
              <PatientComplianceAnalyticYearlyFilter />
            </Grid>
          </Grid>
        </Grid>

        <Grid container flexDirection="row" justifyContent="space-between">
          {isLoading || isFetching ? (
            <Loading height="300px" />
          ) : (
            <>
              <Grid
                container
                item
                xs={12}
                sm={5.9}
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item>
                  <Typography
                    variant="h6"
                    style={{ fontSize: "1rem", fontWeight: 500 }}
                  >
                    Day 31 Billing Cycle
                  </Typography>
                </Grid>
                <PatientComplianceAnalyticStat data={data} schedule="day_31" />

                <Divider style={{ marginBottom: "10px" }} />

                <Grid container item flex={1}>
                  <PatientComplianceAnalyticChart
                    data={data}
                    filter={yearlyFilter}
                    schedule="day_31"
                  />
                </Grid>
              </Grid>

              <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />

              <Grid
                item
                xs={12}
                sm={5.9}
                container
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item>
                  <Typography
                    variant="h6"
                    style={{ fontSize: "1rem", fontWeight: 500 }}
                  >
                    Day 91 Billing Cycle
                  </Typography>
                </Grid>
                <PatientComplianceAnalyticStat data={data} schedule="day_91" />

                <Divider style={{ marginBottom: "10px" }} />

                <Grid container item flex={1}>
                  <PatientComplianceAnalyticChart
                    data={data}
                    filter={yearlyFilter}
                    schedule="day_91"
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PatientComplianceAnalytic;
